import { ApiError } from 'src/utils/build-api-client';
import { ResidentPreQualificationModel } from './types';

const MONTHS_PER_YEAR = 12;

const REQUIRED_ERROR_CODE = 'RESIDENT_PRE_QUALIFICATION_REQUIRED';
const NOT_QUALIFIED_ERROR_CODE = 'RESIDENT_PRE_QUALIFICATION_NOT_QUALIFIED';

export function getRentIncomeMultiple({
  reportedAnnualHouseholdIncome,
  rentAmount,
}: ResidentPreQualificationModel) {
  const multiple =
    reportedAnnualHouseholdIncome / (rentAmount * MONTHS_PER_YEAR);

  return String(Math.floor(multiple * 10) / 10);
}

export function doesIncomeMeetThreshold({
  estimatedOutcome,
  reportedCreditScoreBand,
}: ResidentPreQualificationModel) {
  return (
    estimatedOutcome === 'Qualified' ||
    (estimatedOutcome === 'CosignerRequired' &&
      reportedCreditScoreBand === 'Poor')
  );
}

export function isPreQualificationRequiredError(error: unknown) {
  return error instanceof ApiError && error.code === REQUIRED_ERROR_CODE;
}

export function getPreQualificationGateMessage(error: unknown) {
  return error instanceof ApiError && error.code === NOT_QUALIFIED_ERROR_CODE
    ? error.error
    : undefined;
}
